import m from 'mithril'

import { removeParam } from 'core/helpers/url-helpers'
import { setAppState } from 'core/services/app-state'
import { getAppState } from 'core/services/app-state'
import VideoOverlay from './VideoOverlay'
import TextOverlay from './TextOverlay'
import AudioOverlay from './AudioOverlay'
import iconExit from './icon-exit.svg'

const templates = {
  video: VideoOverlay,
  text: TextOverlay,
  audio: AudioOverlay,
}

class Overlay {
  constructor(vnode) {
    this.dismiss = this._dismiss.bind(this)
    this.onOverlayView = this._onOverlayView.bind(this)
  }

  oninit(vnode) {
    let state = this
    state.overlay = vnode.attrs.overlay
    const app = getAppState()
    state.viewedOverlays = app.viewedOverlays || []
  }

  onbeforeremove(vnode) {
    let state = this
    vnode.dom.classList.add('is-exiting')
    if (vnode.attrs.overlay.onClose) {
      vnode.attrs.overlay.onClose.call(state, vnode, m)
    }

    return new Promise(resolve => {
      vnode.dom.addEventListener('animationend', resolve)
    })
  }

  _dismiss() {
    removeParam('overlay')
  }


  _onOverlayView(vnode) {
    let state = this
    if(!state.viewedOverlays.includes(vnode.attrs.overlay.id)){
      state.viewedOverlays.push(vnode.attrs.overlay.id) 
      const viewedOverlays = state.viewedOverlays    
      setAppState({ viewedOverlays })
  }
    
  }

  view(vnode) {
    let state = this
    const Template = templates[vnode.attrs.overlay.type]

    if (!Template) return null
    state.onOverlayView(vnode)
    if (Template == AudioOverlay) return (
      <div className="overlay audio" >
        <Template overlay={state.overlay} />
      </div>
    )
    return (
      <div className="overlay" onclick={state.dismiss}>
        <div
          className={`${Template == VideoOverlay ? 'overlay-foreground' : vnode.attrs.overlay.isImage ? 'overlay-info-text image' : 'overlay-info-text'} mod-${state.overlay.type}`}
          onclick={e => {
            e.stopPropagation()
          }}
        >
          <Template overlay={state.overlay} />
          <img className="overlay-btn" src={iconExit} style={`${vnode.attrs.overlay.close_button ? 'right:'+ vnode.attrs.overlay.close_button : ''}`}onclick={state.dismiss} />
        </div>
      </div>
    )
  }
}

export default Overlay
